import React, {useState, useRef} from 'react';
import {connect} from 'react-redux';
import {PortalStep} from './Enum';
import {validateInput, TextInputEnum} from '../../../utilities/validation/InputValidation';
import TextInput from '../../Shared/TextInput/TextInput';
import {setCurrentStep, setUserDetails, setThirdPartyCheck} from './OrganizationPortalSlice';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import Checkbox from '../../Shared/CheckBox/Checkbox';
import AddressForm from '../../Block/SaleJetBlock/Partials/AddressForm/AddressForm';
import OrgFooterButtons from './OrgFooterButtons';
import {goToNextPage} from '../SaleJetBlock/saleBlockAsyncThunk';

const UserPersonalInfo = (props) => {
  const [firstName, setFirstName] = useState(props.userDetails.firstName);
  const [lastName, setLastName] = useState(props.userDetails.lastName);
  const [phone, setPhone] = useState(props.userDetails.subscriberNumber);
  const [altPhone, setAltPhone] = useState('');
  const [email, setEmail] = useState(props.userDetails.mail);
  const [isSubmit, setIsSubmit] = useState('');
  const [errors, setErrors] = useState({firstName: '', lastName: '', phone: '', altPhone: '', mail: '', address: ''});
  const isUpdateAction = props.userDetails.ban != '';
  const phoneRef = useRef();
  const emailRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const altPhoneRef = useRef();

  const selectedAddress = {
    cityName: props.userDetails.address?.city ?? '',
    streetName: props.userDetails.address?.street ?? '',
    home: props.userDetails.address?.houseNum ?? '',
    apartment: props.userDetails.address?.apartment ?? '',
    zipCode: props.userDetails.address?.zipCode ?? '',
    floor: props.userDetails.address?.floor ?? '',
  };

  const goToNextPage = () => {
    if (isUpdateAction) {
      const selectedModel = props.userDetails.selectedPlan.model.itemId ?? null;
      if (selectedModel) {
        props.setCurrentStep({current: PortalStep.UserPaymentInfo, previous: props.steps.current});
      } else {
        props.setCurrentStep({current: PortalStep.OrderSummary, previous: props.steps.current});
      }
      return;
    }
    setIsSubmit(true);
  };

  const handleSubmit = (res) => {
    setIsSubmit(false);
    if (res.isValid) {
      var errorFname = validateInput(firstName, TextInputEnum.FirstName);
      var errorLname = validateInput(lastName, TextInputEnum.LastName);
      var errorMail = validateInput(email, TextInputEnum.Mail);
      var errorPhone = validateInput(phone, TextInputEnum.Phone);
      var errorAltPhone = validateInput(altPhone, TextInputEnum.Phone, false);
      setErrors({...errors, firstName: errorFname, lastName: errorLname, mail: errorMail, phone: errorPhone, altPhone: errorAltPhone});

      if (errorFname == '' && errorLname == '' && errorMail == '' && errorPhone == '' && errorAltPhone == '') {
        props.setUserDetails({
          ...props.userDetails,
          firstName: firstName,
          lastName: lastName,
          mail: email,
          phoneNumber: phone,
          altPhoneNumber: altPhone,
          address: {
            city: res.selectedAddress.cityName,
            street: res.selectedAddress.streetName,
            houseNum: res.selectedAddress.home,
            apartment: res.selectedAddress.apartment,
            zipCode: res.selectedAddress.zipCode,
            floor: res.selectedAddress.floor,
          },
        });
        if (props.steps.previous !== PortalStep.OrderSummary)
          props.setCurrentStep({current: PortalStep.UserPaymentInfo, previous: props.steps.current});
        else props.setCurrentStep({current: PortalStep.OrderSummary});
      }
    }
  };

  return (
    <div className='user_personal_details'>
      <div className='page-container'>
        <div className='step-page_S'>
          <div className='info_section'>
            <span className='M_Title'>פרטים אישיים</span>
            <span className='M_SubTitle'>{ isUpdateAction ? 'לא ניתן לעדכן את פרטי המנוי בשלב זה': 'להשלמת התהליך, מלאו את הפרטים' }</span>
            <div className='org-row-wrapper'>
              <p className='form-remark'> * שדות עם כוכבית הם חובה </p>
              <TextInput value={props.userDetails.userId} id='id' placeholder='תעודת זהות' disabled={true} />
              <TextInput
                value={firstName}
                error={errors.firstName}
                id='firstName'
                placeholder={'שם פרטי'}
                onChange={(e) => {
                  setErrors({...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName)});
                  setFirstName(e.target.value);
                }}
                disabled={isUpdateAction}
                ref={firstNameRef}
                required='required'
              />

              <TextInput
                value={lastName}
                error={errors.lastName}
                id='lastName'
                placeholder={'שם משפחה'}
                onChange={(e) => {
                  setErrors({...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName)});
                  setLastName(e.target.value);
                }}
                ref={lastNameRef}
                required='required'
                disabled={isUpdateAction}
              />

              <TextInput
                value={phone}
                error={errors.phone}
                id='phone'
                placeholder={'מספר טלפון'}
                onChange={(e) => {
                  setErrors({...errors, phone: validateInput(e.target.value, TextInputEnum.Phone)});
                  setPhone(e.target.value);
                }}
                required='required'
                ref={phoneRef}
                disabled={isUpdateAction}
              />
              {!isUpdateAction && (
                <TextInput
                  value={altPhone}
                  error={errors.altPhone}
                  id='altPhone'
                  placeholder={'מספר טלפון נוסף'}
                  onChange={(e) => {
                    setErrors({...errors, altPhone: validateInput(e.target.value, TextInputEnum.Phone, false)});
                    setAltPhone(e.target.value);
                  }}
                  ref={altPhoneRef}
                  disabled={isUpdateAction}
                />
              )}
              {!isUpdateAction && (
                <AddressForm isSubmit={isSubmit} onSubmit={(res) => handleSubmit(res)} selectedAddress={selectedAddress} />
              )}
            </div>
          </div>
          {!isUpdateAction && (
            <div className='info_section'>
              <span className='S_Title'> מה כתובת המייל שלך? </span>
              <span className='S_SubTitle'> אנו נשלח לכתובת זו את החשבונית החודשית</span>
              <div className='org-row-wrapper'>
                <TextInput
                  value={email}
                  error={errors.mail}
                  id='mail'
                  placeholder='מייל'
                  onChange={(e) => {
                    setErrors({...errors, mail: validateInput(e.target.value, TextInputEnum.Mail)});
                    setEmail(e.target.value);
                  }}
                  required='required'
                  ref={emailRef}
                />
                {props.orgDetails.displayThirdPartyCB && (
                  <Checkbox
                    id='terms-checkbox'
                    checked={props.thirdPartyCheck}
                    label={<ThirdParty />}
                    onCheck={() => props.setThirdPartyCheck(true)}
                    onUncheck={() => props.setThirdPartyCheck(false)}></Checkbox>
                )}
              </div>

              {/* <div className='btn-container'>
             <BtnSubmit text={'המשך'} onclick={() => {setIsSubmit(true)}} />
           </div> */}
            </div>
          )}
        </div>
      </div>
      <OrgFooterButtons btnText={'אישור והמשך'} onContinue={() => goToNextPage()} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.organizationPortal.userDetails,
  steps: state.organizationPortal.steps,
  thirdPartyCheck: state.organizationPortal.thirdPartyCheck,
  address: state.saleJetBlock.addressPage.selectedAddress,
  orgDetails: state.organizationPortal.orgDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setUserDetails,
  setThirdPartyCheck,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPersonalInfo);
